export default __webpack_public_path__ + "static/media/Ballroll_00221.91df0bf8.png";